import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { getCoupons } from "../services/Cart";
import LoadingSpinner from "./LoadingSpinner";

const Coupons = ({ showPreview, onOpen, isModalOpen, onClose, activePurchaseType }) => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ---------------- FORMAT DESCRIPTION ---------------- */
  const formatDescription = (desc) => {
    if (!desc) return [];

    return desc
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/\d+\)/g, "")
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);
  };

  /* ---------------- FETCH COUPONS ---------------- */
  useEffect(() => {
    if (!localStorage.getItem("token")) return;

    const fetchCoupons = async () => {
      setLoading(true);
      try {
        const res = await getCoupons();
        setCoupons(res?.Data || []);
      } catch (err) {
        console.error("Coupon error:", err);
        setCoupons([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCoupons();
  }, []);

  /* ---------------- MATCH PURCHASE TYPE ---------------- */
  const isCouponMatchingType = (coupon) => {
    if (!activePurchaseType) return true;
    if (!coupon.purchaseType) return true;
    return coupon.purchaseType === activePurchaseType;
  };

  /* ---------------- ACTIVE COUPONS ---------------- */
  const activeCoupons = coupons.filter((c) => c.active === 1);
  const matchingCoupons = activeCoupons.filter(isCouponMatchingType);

  /* ✅ HIDE EVERYTHING IF NO COUPONS */
  if (!loading && activeCoupons.length === 0) {
    return null;
  }

  /* ---------------- PREVIEW MODE ---------------- */
 if (showPreview) {
  return (
    <div style={{ marginTop: "12px" }}>
      <h4>Coupons</h4>

      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        {activeCoupons.slice(0, 2).map((item) => {
          const disabled = !isCouponMatchingType(item);
          return (
            <div
              key={item.couponid}
              onClick={disabled ? undefined : onOpen}
              style={{
                padding: "8px 14px",
                border: `1px dashed ${disabled ? "#ccc" : "#005487"}`,
                borderRadius: "10px",
                cursor: disabled ? "not-allowed" : "pointer",
                fontWeight: "600",
                fontSize: "13px",
                color: disabled ? "#bbb" : "#005487",
                backgroundColor: disabled ? "#f5f5f5" : "#f4f9ff",
                opacity: disabled ? 0.6 : 1,
              }}
            >
              {item.couponid}
            </div>
          );
        })}

        {activeCoupons.length > 2 && (
          <span
            onClick={onOpen}
            style={{
              cursor: "pointer",
              color: "#005487",
              fontWeight: "600",
              fontSize: "13px",
            }}
          >
            + more
          </span>
        )}
      </div>
    </div>
  );
}

  /* ---------------- MODAL MODE ---------------- */
  return (
    <Modal
      title="Available Coupons"
      open={isModalOpen}
      footer={null}
      onCancel={onClose}
    >
      {loading ? (
        <LoadingSpinner text="Loading coupons..." />
      ) : (
        activeCoupons.map((item) => {
          const disabled = !isCouponMatchingType(item);
          return (
            <div
              key={item.couponid}
              style={{
                backgroundColor: disabled ? "#f0f0f0" : "#f5f7fa",
                padding: "14px",
                borderRadius: "10px",
                marginBottom: "12px",
                opacity: disabled ? 0.5 : 1,
                cursor: disabled ? "not-allowed" : "default",
              }}
            >
              <h3 style={{ fontSize: "14px", fontWeight: "600" }}>
                {item.couponid}
                {disabled && (
                  <span style={{
                    fontSize: "11px",
                    color: "#999",
                    marginLeft: "8px",
                    fontStyle: "italic",
                    fontWeight: "400",
                  }}>
                    (not available for {activePurchaseType} purchase)
                  </span>
                )}
              </h3>

              <ul style={{ paddingLeft: "18px", margin: "8px 0" }}>
                {formatDescription(item.coupondesc).map((point, index) => (
                  <li key={index} style={{ fontSize: "13px" }}>
                    {point}
                  </li>
                ))}
              </ul>

              <p style={{ fontSize: "12px", color: "#666" }}>
                Valid: {item.validfrom} – {item.validto}
              </p>
            </div>
          );
        })
      )}
    </Modal>
  );
};

export default Coupons;
